import { render, staticRenderFns } from "./UserComunity.vue?vue&type=template&id=6af6c02f&"
import script from "./UserComunity.vue?vue&type=script&lang=js&"
export * from "./UserComunity.vue?vue&type=script&lang=js&"
import style0 from "./UserComunity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports